import * as Utils from './lsg-utils';
import { refreshRecommendations } from './lsg-mini-upsell-carousel';


const cartEl        = document.querySelector(`[lsg-cart-handler]`),
      cartURL       = window.Shopify.routes.root + 'cart.js',
      addURL        = window.Shopify.routes.root + 'cart/add.js',
      clearURL      = window.Shopify.routes.root + 'cart/clear.js',
      updateURL     = window.Shopify.routes.root + 'cart/update.js',
      changeURL     = window.Shopify.routes.root + 'cart/change.js',
      inputDelay    = 150,
      debug         = true;

if (debug) console.log(`[LSG] Starting cart handler.`);

const isSlideCart = cartEl.classList.contains(`lsg-slidecart-rebuild`);

cartEl.classList.add(`lsg-cart-handler-active`);

/**
 * Product List
 * snippets/lsg-cart-product-list
 */
const listEl = cartEl.querySelector(`[lsg-cart-product-list]`);

if (listEl) {
    const lineItemEls = listEl.querySelectorAll(`[lsg-cart-line-item]`);
    lineItemEls.forEach((lineItemEl) => {
        processLineItem(lineItemEl);
    });
}

function processLineItem(lineItemEl) {
    const key       = lineItemEl.getAttribute(`lsg-cart-line-item`);
    const payload   = {
        id: key
    };

    if (debug) console.log(`[LSG] Processing line item, key: ${key}`);

    /* Quantity */
    const qtyMinusBtnEl = lineItemEl.querySelector(`[lsg-cart-qty-minus]`),
          qtyPlusBtnEl  = lineItemEl.querySelector(`[lsg-cart-qty-plus]`);
    
    qtyMinusBtnEl.addEventListener(`click`, Utils.debounce((e) => qtyMinusBtnHandler(lineItemEl, payload), inputDelay));
    qtyPlusBtnEl.addEventListener(`click`, Utils.debounce((e) => qtyPlusBtnHandler(lineItemEl, payload), inputDelay));

    /* Remove Items */
    const removeBtnEl   = lineItemEl.querySelector(`[lsg-cart-remove]`);

    removeBtnEl?.addEventListener(`click`, (e) => removeBtnHandler(e, lineItemEl, payload));

    /* Frequency */
    const freqUpgradeBtnEl  = lineItemEl.querySelector(`[lsg-cart-selling-plan-btn]`),
          freqPlanSelectEl  = lineItemEl.querySelector(`[lsg-cart-selling-plan-select]`),
          freqToggleEl      = lineItemEl.querySelector(`[lsg-cart-frequency-toggle] input`);

    freqUpgradeBtnEl?.addEventListener(`click`, (e) => freqUpgradeBtnHandler(e, lineItemEl));
    freqPlanSelectEl?.addEventListener(`change`, (e) => freqPlanSelectHandler(e, lineItemEl));
    freqToggleEl?.addEventListener(`change`, (e) => freqToggleHandler(e, lineItemEl));
}

function errorHandler(lineItemEl, error) {
    console.error(error);
    const errorEl = lineItemEl.querySelector(`[lsg-cart-error]`);
    errorEl.textContent = error;
    lineItemEl.classList.add(`lsg-cart-line-item__has-error`);
}

/**
 * Quantity Handlers
 */
function qtyMinusBtnHandler(lineItemEl, payload) {

    if (debug) console.log(`[LSG] Quantity minus clicked.`);

    const qtyInputEl    = lineItemEl.querySelector(`[lsg-cart-qty-input]`),
          qtyCurrent    = parseInt(qtyInputEl.value);

    let qtyNew          = qtyCurrent - 1;
    payload.quantity    = qtyNew;

    Utils.apiCall('POST', changeURL, payload).then(cartData => {
        const itemData      = cartData.items.find(i => i.key === payload.id);

        if (typeof itemData === `undefined`) {
            lineItemEl.remove();
        } else {
            qtyInputEl.setAttribute(`value`, itemData.quantity);
        }

        fetchAndRenderCart();
    }).catch(error => {
        errorHandler(lineItemEl, error);
    });
}

function qtyPlusBtnHandler(lineItemEl, payload) {

    if (debug) console.log(`[LSG] Quantity plus clicked.`);

    const qtyInputEl    = lineItemEl.querySelector(`[lsg-cart-qty-input]`),
          qtyMax        = parseInt(qtyInputEl.getAttribute(`max`)),
          qtyCurrent    = parseInt(qtyInputEl.value);

    let qtyNew;

    if (qtyCurrent === qtyMax) {
        return;
    } else if (qtyCurrent > qtyMax) {
        qtyNew = qtyMax;
    } else {
        qtyNew = qtyCurrent + 1;
    }

    payload.quantity    = qtyNew;

    Utils.apiCall('POST', changeURL, payload).then(cartData => {
        const itemData      = cartData.items.find(i => i.key === payload.id);
        qtyInputEl.setAttribute(`value`, itemData.quantity);
        fetchAndRenderCart();
    }).catch(error => {
        errorHandler(lineItemEl, error);
    });
}

function removeBtnHandler(e, lineItemEl, payload) {

    if (debug) console.log(`[LSG] Remove item clicked.`);

    e.preventDefault();
    payload.quantity    = 0;
    Utils.apiCall('POST', changeURL, payload).then(cartData => {
        lineItemEl.remove();
        fetchAndRenderCart();
    }).catch(error => {
        errorHandler(lineItemEl, error);
    });
}


/**
 * Frequency Handlers
 */
function freqUpgradeBtnHandler(e, lineItemEl) {
    const key               = lineItemEl.getAttribute(`lsg-cart-line-item`),
          freqGroupEl       = lineItemEl.querySelector(`[lsg-cart-frequency-group]`),
          freqPlanSelectEl  = lineItemEl.querySelector(`[lsg-cart-selling-plan-select]`),
          firstPlanId       = freqPlanSelectEl.querySelector(`[lsg-cart-first-selling-plan]`).value,
          currentQty        = lineItemEl.querySelector(`[lsg-cart-qty-input]`).value;
    
    const payload = {
        'id':       key,
        'quantity': currentQty
    };

    if (debug) console.log(`[LSG] Frequency upgrade button clicked, plan ID: ${firstPlanId}`);

    payload.selling_plan = firstPlanId;

    Utils.apiCall('POST', changeURL, payload).then(cartData => {
        if (debug) console.log(cartData);
        freqPlanSelectEl.value = firstPlanId;
        freqGroupEl.classList.add(`lsg-cart-line-item__frequency-has-spa`);
        fetchAndRenderCart();
    }).catch(error => {
        errorHandler(lineItemEl, error);
    });
}

function freqPlanSelectHandler(e, lineItemEl) {
    const key               = lineItemEl.getAttribute(`lsg-cart-line-item`),
          freqGroupEl       = lineItemEl.querySelector(`[lsg-cart-frequency-group]`),
          selectedPlanId    = e.target.value,
          selectedVariant   = parseInt(e.target.options[e.target.selectedIndex].getAttribute(`lsg-cart-freq-variant`)),
          addVariant        = parseInt(e.target.options[e.target.selectedIndex].getAttribute(`lsg-cart-freq-add-variant`)),
          currentQty        = lineItemEl.querySelector(`[lsg-cart-qty-input]`).value,
          currentVariant    = parseInt(key.split(`:`)[0]);
    
    if (debug) console.log(`[LSG] Frequency plan select changed!`);
    if (debug) console.log(`[LSG] selectedPlanId:`, selectedPlanId);
    if (debug) console.log(`[LSG] selectedVariant:`, selectedVariant);
    if (debug) console.log(`[LSG] addVariant:`, addVariant);
    if (debug) console.log(`[LSG] currentVariant:`, currentVariant);

    if (isNaN(selectedVariant) && !isNaN(addVariant))
    {

        if (debug) console.log(`[LSG] Add variant selected.`);

        const payloadAdd = {
            'items': [{
                'id': addVariant,
                'quantity': 1,
                'properties': {
                    '_added_item': true
                }
            }]
        };

        Utils.apiCall('POST', addURL, payloadAdd).then(cartData => {
            lineItemEl.remove();

            cartData.items.forEach((item) => {
                const lineItemEl = cartEl.querySelector(`[lsg-cart-line-item="${item.key}"]`);
        
                if (lineItemEl) {
                    if (debug) console.log(`[LSG] Updating existing.`);
                    if (isSlideCart) {
                        if (debug) console.log(`[LSG] Opening Slide Cart.`);
                        window.LSG_OPEN_CART();
                    } else {
                        if (debug) console.log(`[LSG] Not opening Slide Cart.`);
                    };
                    fetchAndRenderCart();
                } else {
                    if (debug) console.log(`[LSG] Adding item.`);
                    fetchProductAndAddToCart(item);
                }
            });

        }).catch(error => {
            console.error(error);
            alert(error);
        });

    }
    else if (selectedVariant !== currentVariant)
    {

        if (debug) console.log(`[LSG] Changing to variant with matching selling plan.`);

        const payloadRemove   = {
            id: key,
            quantity: 0
        };

        const payloadAdd = {
            'items': [{
                'id': selectedVariant,
                'quantity': currentQty,
                'selling_plan': selectedPlanId
            }]
        };

        Utils.apiCall('POST', changeURL, payloadRemove).then(() => {

            Utils.apiCall('POST', addURL, payloadAdd).then(cartData => {
                lineItemEl.remove();

                cartData.items.forEach((item) => {
                    const lineItemEl = cartEl.querySelector(`[lsg-cart-line-item="${item.key}"]`);
            
                    if (lineItemEl) {
                        if (debug) console.log(`[LSG] Updating existing.`);
                        if (isSlideCart) {
                            if (debug) console.log(`[LSG] Opening Slide Cart.`);
                            window.LSG_OPEN_CART();
                        } else {
                            if (debug) console.log(`[LSG] Not opening Slide Cart.`);
                        };
                        fetchAndRenderCart();
                    } else {
                        if (debug) console.log(`[LSG] Adding item.`);
                        fetchProductAndAddToCart(item);
                    }
                });

            }).catch(error => {
                console.error(error);
                alert(error);
            });

        }).catch(error => {
            errorHandler(lineItemEl, error);
        });

    } else {
    
        const payload = {
            'id':       key,
            'quantity': currentQty
        };
    
        if (selectedPlanId === "") {
            payload.selling_plan = null;
    
            Utils.apiCall('POST', changeURL, payload).then(cartData => {
                if (debug) console.log(cartData);
                freqGroupEl.classList.remove(`lsg-cart-line-item__frequency-has-spa`);
                fetchAndRenderCart();
            }).catch(error => {
                errorHandler(lineItemEl, error);
            });
        } else {
            payload.selling_plan = selectedPlanId;
    
            Utils.apiCall('POST', changeURL, payload).then(cartData => {
                if (debug) console.log(cartData);
                fetchAndRenderCart();
            }).catch(error => {
                errorHandler(lineItemEl, error);
            });
        }

    }
}

function freqToggleHandler(e, lineItemEl) {
    const key               = lineItemEl.getAttribute(`lsg-cart-line-item`),
          freqGroupEl       = lineItemEl.querySelector(`[lsg-cart-frequency-group]`),
          freqLabelEl       = lineItemEl.querySelector(`[lsg-cart-frequency-toggle]`),
          selectedPlanId    = freqLabelEl.getAttribute(`lsg-cart-frequency-selling-plan-id`),
        //   selectedVariant   = parseInt(e.target.options[e.target.selectedIndex].getAttribute(`lsg-cart-freq-variant`)),
          currentQty        = lineItemEl.querySelector(`[lsg-cart-qty-input]`).value;
    
    if (debug) console.log(`[LSG] Frequency plan select changed!`);
    if (debug) console.log(`[LSG] selectedPlanId:`, selectedPlanId);
    // if (debug) console.log(`[LSG] selectedVariant:`, selectedVariant);
    
    const payload = {
        'id':       key,
        'quantity': currentQty
    };

    if (selectedPlanId === "") {
        payload.selling_plan = null;

        Utils.apiCall('POST', changeURL, payload).then(cartData => {
            if (debug) console.log(cartData);
            freqGroupEl.classList.remove(`lsg-cart-line-item__frequency-has-spa`);
            fetchAndRenderCart();
        }).catch(error => {
            errorHandler(lineItemEl, error);
        });
    } else {
        payload.selling_plan = selectedPlanId;

        Utils.apiCall('POST', changeURL, payload).then(cartData => {
            if (debug) console.log(cartData);
            fetchAndRenderCart();
        }).catch(error => {
            errorHandler(lineItemEl, error);
        });
    }

}


/**
 * Take over product forms
 */
const productFormEls    = document.querySelectorAll('.shopify-product-form');

productFormEls.forEach((productFormEl) => {
    productFormEl.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData  = new FormData(e.target);
        // Klaviyo object initialization
        !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
        const objectData = Object.fromEntries(formData);
        klaviyo.push(["track", "Added to Cart", {
            "AddedItemProductID": objectData.id,
            "AddedItemQuantity": parseInt(objectData.quantity)
          }]);

        if (debug) console.log(`[LSG] Intercepted product form:`, formData);

        processAndAddToCart(formData, productFormEl);
    });
});

/**
 * Add to Cart
 */
export function processAndAddToCart(formData, productFormEl) {
    const formBtnEl = productFormEl.querySelector(`[type="submit"]`);
    if (debug) console.log(`[LSG] formBtnEl:`, formBtnEl);

    if (formBtnEl) {
        const savedInnerHTML = formBtnEl.innerHTML;
        formBtnEl.style.pointerEvents = `none`;

        const loadingEl = document.createElement(`div`);
        loadingEl.classList.add(`lsg-loading-spinner`);
        for (let i = 0; i < 4; i++) {
            let circleEl = document.createElement(`div`);
            loadingEl.appendChild(circleEl);
        }
        formBtnEl.innerHTML = ``;
        formBtnEl.appendChild(loadingEl);

        if (debug) console.log(`[LSG] loadingEl:`, loadingEl);

        setTimeout(() => {
            formBtnEl.style.pointerEvents = `all`;
            formBtnEl.innerHTML = savedInnerHTML;
        }, 1000);
    }

    Utils.apiCall('GET', cartURL).then(cartData => {

        /* Processing */
        const objectData = Object.fromEntries(formData);
        const productId = parseInt(objectData["product-id"]);
    
        if (debug) console.log(`[LSG] cartData:`, cartData);
        if (debug) console.log(`[LSG] objectData:`, objectData);
        if (debug) console.log(`[LSG] objectData["product-id"]:`, objectData["product-id"]);

        const matchesInCart = cartData.items.filter((item) => item.product_id === productId);
        if (debug) console.log(`[LSG] matchesInCart:`, matchesInCart);

        let productHandle;
        if (matchesInCart.length > 0) {
            productHandle = matchesInCart[0].handle;
        }
        if (debug) console.log(`[LSG] productHandle:`, productHandle);

        let existingQty = 0;
        matchesInCart.forEach((item) => {
            existingQty += item.quantity;
        });
        if (debug) console.log(`[LSG] existingQty:`, existingQty);

        if (typeof productHandle !== 'undefined') {

            const metafieldsURL = `/products/${productHandle}?view=lsg-metafields`;
            if (debug) console.log(`[LSG] metafieldsURL:`, metafieldsURL);

            Utils.apiCall('GET', metafieldsURL).then(metafieldsData => {

                if (debug) console.log(`[LSG] metafieldsData:`, metafieldsData);
    
                if (typeof metafieldsData.limit_quantity !== 'undefined') {
                    if (existingQty >= metafieldsData.limit_quantity || (objectData.quantity + existingQty) >= metafieldsData.limit_quantity) {
                        const message = `Error: You already have the maximum quantity of this item in your cart (${metafieldsData.limit_quantity}).`
                        console.error(`[LSG] Quantity limited, cannot add to cart. Message:`, message);
                        alert(message);
                        return;
                    }
                }
        
                let payload = {
                    'items': [{
                        'id': objectData.id,
                        'quantity': objectData.quantity,
                    }]
                };
            
                if (typeof objectData.selling_plan !== 'undefined') {
                    payload['items'][0]['selling_plan'] = objectData.selling_plan;
                }
            
                let properties = {};
            
                Object.entries(objectData).forEach((data) => {
                    if (data[0].includes(`properties`)) {
                        const propertyName  = data[0].split(`[`).pop().split(`]`)[0],
                              propertyValue = data[1];
            
                        properties[`${propertyName}`] = propertyValue;
                    }
                });
            
                payload['items'][0]['properties'] = properties;
            
                if (debug) console.log(`[LSG] Processing and adding to cart:`, payload);
            
                Utils.apiCall('POST', addURL, payload).then(cartData => {
            
                    cartData.items.forEach((item) => {
                        const lineItemEl = cartEl.querySelector(`[lsg-cart-line-item="${item.key}"]`);
                
                        if (lineItemEl) {
                            if (debug) console.log(`[LSG] Updating existing.`);
                            if (isSlideCart) {
                                if (debug) console.log(`[LSG] Opening Slide Cart.`);
                                window.LSG_OPEN_CART();
                            } else {
                                if (debug) console.log(`[LSG] Not opening Slide Cart.`);
                            };
                            fetchAndRenderCart();
                        } else {
                            if (debug) console.log(`[LSG] Adding item.`);
                            fetchProductAndAddToCart(item);
                        }
                    });
            
                }).catch(error => {
                    console.error(error);
                    alert(error);
                });
    
            });

        } else {

            let payload = {
                'items': [{
                    'id': objectData.id,
                    'quantity': objectData.quantity,
                }]
            };
        
            if (typeof objectData.selling_plan !== 'undefined') {
                payload['items'][0]['selling_plan'] = objectData.selling_plan;
            }
        
            let properties = {};
        
            Object.entries(objectData).forEach((data) => {
                if (data[0].includes(`properties`)) {
                    const propertyName  = data[0].split(`[`).pop().split(`]`)[0],
                          propertyValue = data[1];
        
                    properties[`${propertyName}`] = propertyValue;
                }
            });
        
            payload['items'][0]['properties'] = properties;
        
            if (debug) console.log(`[LSG] Processing and adding to cart:`, payload);
        
            Utils.apiCall('POST', addURL, payload).then(cartData => {
        
                cartData.items.forEach((item) => {
                    const lineItemEl = cartEl.querySelector(`[lsg-cart-line-item="${item.key}"]`);
            
                    if (lineItemEl) {
                        if (debug) console.log(`[LSG] Updating existing.`);
                        if (isSlideCart) {
                            if (debug) console.log(`[LSG] Opening Slide Cart.`);
                            window.LSG_OPEN_CART();
                        } else {
                            if (debug) console.log(`[LSG] Not opening Slide Cart.`);
                        };
                        fetchAndRenderCart();
                    } else {
                        if (debug) console.log(`[LSG] Adding item.`);
                        fetchProductAndAddToCart(item);
                    }
                });
        
            }).catch(error => {
                console.error(error);
                alert(error);
            });

        }

    }).catch(error => {
        console.error(error);
        alert(error);
    });
}

function fetchProductAndAddToCart(itemData) {
    const productURL = window.Shopify.routes.root + 'products/' + itemData.handle + '.js',
          metafieldsURL = `/products/${itemData.handle}?view=lsg-metafields`;

    if (debug) console.log(`[LSG] productURL:`, productURL);
    if (debug) console.log(`[LSG] metafieldsURL:`, metafieldsURL);

    Utils.apiCall('GET', productURL).then(productData => {

        Utils.apiCall('GET', metafieldsURL).then(metafieldsData => {
            productData.metafields = metafieldsData;
            addToCart(itemData, productData);
            fetchAndRenderCart();
        });
    });
}

function addToCart(itemData, productData) {

    if (debug) console.log(`[LSG] addToCart process, itemData:`, itemData);
    if (debug) console.log(`[LSG] addToCart process, productData:`, productData);

    const sectionId             = cartEl.getAttribute(`data-section-id`),
          templateEl            = document.querySelector(`template[data-section-id="${sectionId}"]`),
          cloneEl               = templateEl.content.firstElementChild.cloneNode(true),
          cloneImgEl            = cloneEl.querySelector(`img`),
          cloneDetailItemsEl    = cloneEl.querySelector(`.lsg-cart-line-item__detail-items`),
          cloneTitleEl          = cloneEl.querySelector(`.lsg-cart-line-item__title`),
          cloneDescEl           = cloneEl.querySelector(`.lsg-cart-line-item__description`),
          cloneVariantTitleEl   = cloneEl.querySelector(`.lsg-cart-line-item__variant-title`),
          cloneOptionsListEl    = cloneEl.querySelector(`.lsg-cart-line-item__options-list`),
          cloneQtyInputEl       = cloneEl.querySelector(`[lsg-cart-qty-input]`),
          clonePriceGroupEl     = cloneEl.querySelector(`[lsg-price-group]`);


    /* Line Item Key */
    cloneEl.setAttribute(`lsg-cart-line-item`, itemData.key);


    /* Product Image */
    cloneImgEl.src = Utils.imgURL(itemData.image, 'medium');
    if (typeof productData.metafields.cart_slide_product_image !== 'undefined') {
        cloneImgEl.src = productData.metafields.cart_slide_product_image;
    }


    /* Product Title */
    cloneTitleEl.textContent = itemData.product_title;


    /* Description */
    if (cloneDescEl && typeof productData.metafields.over_title_text !== 'undefined')
    {
        cloneDescEl.textContent = productData.metafields.over_title_text;
    }


    /* Variant Title */
    if (cloneVariantTitleEl) {
        cloneVariantTitleEl.textContent = itemData.variant_title;
    }
    

    /* Options */
    if (cloneOptionsListEl && itemData.options_with_values[0].value !== 'Default Title') {
        itemData.options_with_values.forEach((option) => {
            const optionListEl = document.createElement(`li`);
            optionListEl.classList.add(`lsg-cart-line-item__option-list-item`);
            optionListEl.textContent = `${option.name}: ${option.value}`;
            cloneOptionsListEl.append(optionListEl);
        });
    } else {
        cloneOptionsListEl.remove();
    }


    /* Properties */
    if (itemData.properties) {
        const propertiesArr = Object.entries(itemData.properties);
        if (propertiesArr.length) {
            const propertiesListEl = document.createElement(`ul`);
    
            propertiesListEl.classList.add(`lsg-cart-line-item__properties-list`);
    
            propertiesArr.forEach((property) => {
        
                if (debug) console.log(`[LSG] property:`, property);
    
                // TODO:
                // handle '/uploads/' scenario
        
                if (property[0].charAt(0) === `_`) return;
                if (property[1] === ``) return;
    
                const propertyListEl = document.createElement(`li`);
                propertyListEl.classList.add(`lsg-cart-line-item__properties-list-item`);
                propertyListEl.textContent = `${property[0]}: ${property[1]}`;
                propertiesListEl.append(propertyListEl);
            });
    
            cloneDetailItemsEl.append(propertiesListEl);
        }
    }


    /* Quantity */
    cloneQtyInputEl.setAttribute(`value`, itemData.quantity);
    if (typeof productData.metafields.limit_quantity !== 'undefined')
    {
        cloneQtyInputEl.setAttribute(`max`, productData.metafields.limit_quantity);
    }


    /* Frequency */
    let itemHasSpa = false;
    
    if (typeof productData.selling_plan_groups !== 'undefined' && productData.selling_plan_groups.length > 0) {
        if (debug) console.log(`[LSG] Product has selling plan groups.`);

        const variantData = productData.variants.find(v => v.id === parseInt(itemData.variant_id));
        if (debug) console.log(`[LSG] variantData:`, variantData);

        let freqControlType = 'lsg-freq-checkbox';
        if (typeof productData.metafields.cart_subscription_type !== 'undefined') {
            freqControlType = productData.metafields.cart_subscription_type;
        }

        // Frequency Group Element
        const freqGroupEl = document.createElement(`div`);
        freqGroupEl.classList.add(`lsg-cart-line-item__frequency`);
        freqGroupEl.setAttribute(`lsg-cart-frequency-group`, ``);
        freqGroupEl.setAttribute(`lsg-cart-frequency-type`, freqControlType);

        const freqLabelEl         = document.createElement(`label`),
            freqSelectEl        = document.createElement(`select`),
            freqSelectWrapperEl = document.createElement(`div`);

        if (freqControlType === 'lsg-freq-checkbox') {
            // Frequency Toggle/Checkbox Element

            freqLabelEl.classList.add(`lsg-cart-line-item__freq-checkbox`);
            freqLabelEl.setAttribute(`lsg-cart-frequency-toggle`, ``);

            freqGroupEl.append(freqLabelEl);
        }
        else if (freqControlType === 'lsg-freq-select') {
            // Frequency Button Element
            const freqBtnEl     = document.createElement(`button`),
                  freqBtnTextEl = document.createElement(`span`);
            
            freqBtnEl.classList.add(`lsg-button`, `lsg-button__style-2`);
            freqBtnEl.setAttribute(`type`, `button`);
            freqBtnEl.setAttribute(`lsg-cart-selling-plan-btn`, ``);
            freqBtnTextEl.textContent = `Subscribe & Save`;
            freqBtnEl.append(freqBtnTextEl);
    
            freqGroupEl.append(freqBtnEl);
    
            // Frequency Select Element
            const freqSelectOptOTPEl    = document.createElement(`option`);

            freqSelectWrapperEl.classList.add(`lsg-select-wrapper`);
            freqSelectEl.setAttribute(`name`, `selling_plan`);
            freqSelectEl.setAttribute(`lsg-cart-selling-plan-select`, ``);
            freqSelectOptOTPEl.textContent = `One-Time Purchase`;
            freqSelectOptOTPEl.setAttribute(`value`, ``);
            freqSelectEl.append(freqSelectOptOTPEl);
        }

        const sellingPlanId = itemData.selling_plan_allocation?.selling_plan?.id;
        if (sellingPlanId) {
            if (debug) console.log(`[LSG] Item has selling plan, id:`, sellingPlanId);
            freqGroupEl.classList.add(`lsg-cart-line-item__frequency-has-spa`);
            itemHasSpa = true;
        }

        let unsetFrequencyCheckbox = true;
        variantData.selling_plan_allocations.forEach((spa, i) => {
            const spGroupData   = productData.selling_plan_groups.find(g => g.id === spa.selling_plan_group_id),
                  spData        = spGroupData.selling_plans.find(sp => sp.id === parseInt(spa.selling_plan_id));
            
            if (debug) console.log(`[LSG] spData:`, spData);

            const freqSelectOptEl = document.createElement(`option`);
            freqSelectOptEl.setAttribute(`value`, spData.id);
            freqSelectOptEl.textContent = spData.name;
            if (i === 0) freqSelectOptEl.setAttribute(`lsg-cart-first-selling-plan`, ``);
            if (spa.selling_plan_id === sellingPlanId) freqSelectOptEl.setAttribute(`selected`, ``);

            freqSelectEl.append(freqSelectOptEl);

            if (freqControlType === 'lsg-freq-checkbox' && unsetFrequencyCheckbox && freqLabelEl) {
                if (!sellingPlanId || sellingPlanId == spa.selling_plan_id) {
                    freqLabelEl.setAttribute(`lsg-cart-frequency-selling-plan-id`, spa.selling_plan_id);

                    const freqCTAEl = document.createElement(`div`),
                          freqInputEl = document.createElement(`input`),
                          freqCTATextEl = document.createElement(`div`),
                          freqTitleEl = document.createElement(`span`),
                          freqDiscountEl = document.createElement(`span`);
                    
                    freqCTAEl.classList.add(`lsg-freq-checkbox-cta`);
                    freqInputEl.setAttribute(`type`, `checkbox`);
                    freqCTATextEl.classList.add(`lsg-freq-checkbox-cta__text`);
                    freqTitleEl.textContent = `Subscribe &`;
                    freqDiscountEl.classList.add(`lsg-freq-checkbox-cta__badge`);
                    freqDiscountEl.textContent = `Save ${Math.floor(spData.price_adjustments[0].value)}%`;

                    if (spa.selling_plan_id === sellingPlanId) {
                        freqInputEl.checked = true;
                        freqLabelEl.setAttribute(`lsg-cart-frequency-selling-plan-id`, ``);
                    }

                    freqCTATextEl.append(freqTitleEl);
                    freqCTATextEl.append(freqDiscountEl);
                    freqCTAEl.append(freqInputEl);
                    freqCTAEl.append(freqCTATextEl);
                    freqLabelEl.append(freqCTAEl);
            
                    const freqPlanEl = document.createElement(`div`),
                          freqPlanTextEl = document.createElement(`span`);
                    
                    freqPlanEl.classList.add(`lsg-freq-checkbox-plan`);
                    freqPlanTextEl.textContent = spData.name;

                    freqPlanEl.append(freqPlanTextEl);
                    freqLabelEl.append(freqPlanEl);

                    unsetFrequencyCheckbox = false;
                }
            }
        });
        
        if (freqControlType === 'lsg-freq-checkbox') {
            // Insert Toggle/Checkbox
            freqGroupEl.append(freqLabelEl);
        } else if (freqControlType === 'lsg-freq-select') {
            // Insert Select
            freqSelectWrapperEl.append(freqSelectEl);
            freqGroupEl.append(freqSelectWrapperEl);
        }

        cloneEl.append(freqGroupEl);
        cloneEl.classList.add(`lsg-cart-line-item__has-frequency`);
        cloneEl.classList.add(freqControlType);
    }


    /* Pricing */
    const priceEl = clonePriceGroupEl.querySelector(`[lsg-price]`);

    let price           = itemData.final_price,
        comparePrice    = itemData.original_price;
    
    if (itemHasSpa) {
        if (debug) console.log(`[LSG] Selling plan pricing.`);
        price           = itemData.selling_plan_allocation.price;
        comparePrice    = itemData.selling_plan_allocation.compare_at_price;
    } else if (productData.compare_at_price && productData.compare_at_price !== itemData.price) {
        if (debug) console.log(`[LSG] Sale pricing.`);
        price           = itemData.price;
        comparePrice    = productData.compare_at_price;
    }

    let comparePriceOrig = comparePrice;

    if (debug) console.log(`[LSG] price: ${price}, comparePrice: ${comparePrice}, itemData.quantity: ${itemData.quantity}`);

    price           = price * itemData.quantity;
    comparePrice    = comparePrice * itemData.quantity;

    if (debug) console.log(`[LSG] price: ${price}, comparePrice: ${comparePrice}`);

    priceEl.textContent = Utils.formatter.format(price / 100);
    clonePriceGroupEl.append(priceEl);

    if (price !== comparePrice) {
        const dividerEl = document.createElement(`span`);
        dividerEl.setAttribute(`lsg-price-divider`, ``);
        dividerEl.textContent = `-`;
        clonePriceGroupEl.append(dividerEl);

        const compareEl = document.createElement(`span`);
        compareEl.classList.add(`lsg-price__price-compare`);
        compareEl.setAttribute(`lsg-price-compare`, comparePriceOrig);
        compareEl.textContent = Utils.formatter.format(comparePrice / 100);
        clonePriceGroupEl.append(compareEl);
    }


    /* Process and prepend */
    processLineItem(cloneEl);
    listEl.prepend(cloneEl);

    cartEl.classList.remove(`lsg-cart-empty`);
    if (isSlideCart) {
        if (debug) console.log(`[LSG] Opening Slide Cart.`);
        window.LSG_OPEN_CART();
    } else {
        if (debug) console.log(`[LSG] Not opening Slide Cart.`);
    };

    /* // Klaviyo ATC Tracking
    !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
    klaviyo.push(["track", "Added to Cart", {
        "$value": (itemData.final_price / 100.00),
        "AddedItemProductName": itemData.title,
        "AddedItemProductID": "" + itemData.id,
        "AddedItemSKU": itemData.sku,
        "AddedItemImageURL": itemData.featured_image.url,
        "AddedItemURL": "https://" + window.Shopify.shop + itemData.url,
        "AddedItemPrice": (itemData.price / 100.00),
        "AddedItemQuantity": itemData.quantity,
        "CheckoutURL": "https://" + window.Shopify.shop + "/checkout"
    }]); */
}


/**
 * Render Cart
 */
function fetchAndRenderCart() {
    Utils.apiCall('GET', cartURL).then(cartData => {

        /* Remove Missing Items */
        const lineItemEls = listEl.querySelectorAll(`[lsg-cart-line-item]`);
        lineItemEls.forEach((lineItemEl) => {
            const key       = lineItemEl.getAttribute(`lsg-cart-line-item`),
                  itemData  = cartData.items.find(i => i.key === key);
            
            /* Remove item if no data */
            if (!itemData) {
                if (debug) console.log(`[LSG] No item data for key ${key}, removing.`);
                lineItemEl.remove();
            }
        });

        /* Add New Items */
        const productAddPromises = [];
        cartData.items.forEach((item) => {
            const lineItemEl = listEl.querySelector(`[lsg-cart-line-item="${item.key}"]`);
            if (!lineItemEl) {
                if (debug) console.log(`[LSG] Key not found (${item.key}), adding to cart.`);
                const promise = fetchProductAndAddToCart(item);
                productAddPromises.push(promise);
            }
        });

        Promise.all(productAddPromises).then(() => {
            Utils.apiCall('GET', cartURL).then(cartData => {
                renderCart(cartData);
            });
        });

    });
}

window.LSG_RENDER_CART = () => {fetchAndRenderCart()};

// Upsell Placement Setup
const upsellPlacement   = cartEl.getAttribute(`lsg-cart-upsell-placement`),
      upsellEl          = cartEl.querySelector(`[lsg-recommendations]`),
      listWrapperEl     = cartEl.querySelector(`.lsg-slidecart-rebuild__inner-wrapper`),
      nextSiblingEl     = upsellEl.nextElementSibling;

function renderCart(cartData) {

    if (debug) console.log(`[LSG] Render cart process started.`);
    if (debug) console.log(cartData);

    /**
     * Update Recommendations
     */
    if (cartData.item_count > 0) {
        const productId = cartData.items[0].product_id;
        refreshRecommendations(productId);
    }

    /**
     * Cart Empty
     */
    if (cartData.item_count === 0) {
        cartEl.classList.add(`lsg-cart-empty`);
    } else {
        cartEl.classList.remove(`lsg-cart-empty`);
    }

    /**
     * Product List
     * snippets/lsg-cart-product-list
     */
    const listEl = cartEl.querySelector(`[lsg-cart-product-list]`);

    if (listEl) {

        if (debug) console.log(`[LSG] Rendering line items.`);

        cartData.items.forEach((item) => {

            const lineItemEl = listEl.querySelector(`[lsg-cart-line-item="${item.key}"]`);
            if (lineItemEl) {

                if (debug) console.log(`[LSG] Updating line item matching key: ${item.key}`);

                /* Quantity */
                const qtyInputEl    = lineItemEl.querySelector(`[lsg-cart-qty-input]`);

                qtyInputEl.setAttribute(`value`, item.quantity);
                
                /* Pricing */
                const priceEl       = lineItemEl.querySelector(`[lsg-price]`),
                      compareEl     = lineItemEl.querySelector(`[lsg-price-compare]`);
            
                if (compareEl) {
                    const compareOrig = compareEl.getAttribute(`lsg-price-compare`);
                    let comparePrice = compareOrig * item.quantity;
                    compareEl.innerHTML = Utils.formatter.format(comparePrice / 100);
                }
    
                priceEl.innerHTML = Utils.formatter.format(item.final_line_price / 100);

                /* Reordering */
                listEl.append(lineItemEl);
            } else {
                console.error(`[LSG] Key not found (${item.key})!`);
            }

        });
    }

    /**
     * Upsell Placement
     */
    if (upsellEl && nextSiblingEl && upsellPlacement === 'layout-1') {
        if (cartData.items.length > 0) {
            listWrapperEl.append(upsellEl);
        } else {
            if (debug) console.log(`[LSG] nextSiblingEl:`, nextSiblingEl);
            if (nextSiblingEl.parentElement === cartEl) {
                cartEl.insertBefore(upsellEl, nextSiblingEl);
            }
        }
    }

    if (upsellEl && nextSiblingEl && upsellPlacement === 'layout-2') {
        if (cartData.items.length > 1) {
            listWrapperEl.append(upsellEl);
        } else {
            if (debug) console.log(`[LSG] nextSiblingEl:`, nextSiblingEl);
            if (nextSiblingEl.parentElement === cartEl) {
                cartEl.insertBefore(upsellEl, nextSiblingEl);
            }
        }
    }

    /**
     * Shipping Progress
     * snippets/lsg-cart-shipping-progress
     */
    const shippingEl    = cartEl.querySelector(`[lsg-cart-shipping-progress]`);

    if (shippingEl) {
        const threshold         = parseInt(shippingEl.getAttribute(`lsg-cart-shipping-progress-threshold`)),
              successText       = shippingEl.getAttribute(`lsg-cart-shipping-progress-success-text`),
              progressTextEl    = shippingEl.querySelector(`[lsg-cart-shipping-progress-text]`),
              progressBarEl     = shippingEl.querySelector(`[lsg-cart-shipping-progress-bar]`),
              shippingText      = cartEl.querySelector(`[lsg-cart-subtotal-shipping]`);
        
        let diff    = Math.max(threshold - cartData.total_price, 0),
            percent = Math.min(cartData.total_price / threshold * 100, 100);
        
        progressBarEl.style.width = `${percent}%`;
        
        if (percent === 100) {
            cartEl.classList.add(`lsg-cart-hide-upsells`);
            progressTextEl.innerHTML = successText;
            if (shippingText) {
                shippingText.innerHTML = `FREE`;
            }
        } else {
            cartEl.classList.remove(`lsg-cart-hide-upsells`);
            progressTextEl.innerHTML = `
                <span class="lsg-cart-shipping-progress__prefix">You are</span>
                <span class="lsg-cart-shipping-progress__amount">${Utils.formatter.format(diff / 100)}</span>
                <span class="lsg-cart-shipping-progress__suffix">from <strong>FREE SHIPPING</strong></span>
            `;
            if (shippingText) {
                shippingText.innerHTML = `Calculated at checkout`;
            }
        }
    }

    /**
     * Subtotal
     * snippets/lsg-cart-subtotal
     */
    const subtotalEl    = cartEl.querySelector(`[lsg-cart-subtotal]`);

    if (subtotalEl) {
        const subtotalPriceGroupEl  = subtotalEl.querySelector(`.lsg-cart-subtotal__price`),
              subtotalCountEl       = subtotalEl.querySelector(`[lsg-cart-subtotal-count]`),
              subtotalAmountEl      = subtotalEl.querySelector(`[lsg-cart-subtotal-amount]`),
              subtotalCompareEl     = subtotalEl.querySelector(`[lsg-cart-subtotal-compare]`);
        
        let subtotalCompare = 0;
        if (listEl) {
            cartData.items.forEach((item) => {
                const lineItemEl = listEl.querySelector(`[lsg-cart-line-item="${item.key}"]`);
                if (lineItemEl) {
                    const compareEl = lineItemEl.querySelector(`[lsg-price-compare]`);
                    if (compareEl) {
                        const compareOrig = compareEl.getAttribute(`lsg-price-compare`);
                        if (debug) console.log(`[LSG] compareOrig:`, compareOrig);
                        let comparePrice = compareOrig * item.quantity;
                        if (debug) console.log(`[LSG] comparePrice:`, comparePrice);
                        subtotalCompare += comparePrice;
                        if (debug) console.log(`[LSG] subtotalCompare:`, subtotalCompare);
                    } else {
                        subtotalCompare += item.price * item.quantity;
                    }
                }
            });
        }
        
        let itemPluralized = (cartData.item_count === 1) ? `Item` : `Items`;
        subtotalCountEl.innerHTML = `(${cartData.item_count} ${itemPluralized})`;

        if (subtotalCompare !== cartData.total_price) {
            if (subtotalCompareEl) {
                subtotalCompareEl.textContent = Utils.formatter.format(subtotalCompare / 100);
            } else {
                const subtotalCompareEl = document.createElement(`span`);
                subtotalCompareEl.setAttribute(`lsg-cart-subtotal-compare`, ``);
                subtotalCompareEl.textContent = Utils.formatter.format(subtotalCompare / 100);
                subtotalPriceGroupEl.append(subtotalCompareEl);

                const subtotalDividerEl = document.createElement(`span`);
                subtotalDividerEl.setAttribute(`lsg-cart-subtotal-divider`, ``);
                subtotalDividerEl.textContent = `-`;
                subtotalPriceGroupEl.append(subtotalDividerEl);
            }
            subtotalEl.classList.remove(`lsg-cart-subtotal__no-compare`);
        } else {
            subtotalEl.classList.add(`lsg-cart-subtotal__no-compare`);
        }

        subtotalAmountEl.textContent = Utils.formatter.format(cartData.total_price / 100);
        subtotalPriceGroupEl.append(subtotalAmountEl);
    }

    /* Cart Icon Badge */
    const cartIconBadgeEls = document.querySelectorAll(`[lsg-cart-icon-badge]`);
    cartIconBadgeEls.forEach((cartIconBadgeEl) => {
        cartIconBadgeEl.textContent = cartData.item_count;
    });

    /* Discount Pairs When SlideCart */
    if (isSlideCart)
    {
        const slideCartEl   = document.querySelector(`.lsg-slidecart-rebuild`),
              checkoutBtnEl = slideCartEl.querySelector(`[lsg-cart-checkout-btn]`);
        
        checkoutBtnEl?.setAttribute(`href`, `/checkout`);

        cartData.items.forEach((item) => {
    
            const metafieldsURL = `/products/${item.handle}?view=lsg-metafields`;
        
            if (debug) console.log(`[LSG] metafieldsURL:`, metafieldsURL);
    
            if (typeof item.selling_plan_allocation !== 'undefined') {
    
                Utils.apiCall('GET', metafieldsURL).then(metafieldsData => {
        
                    if (typeof metafieldsData.discount_pair_item !== 'undefined' && metafieldsData.discount_pair_item) {
        
                        if (debug) console.log(`[LSG] Pulled metafields for '${item.handle}':`, metafieldsData);
        
                        const matches = [];
        
                        if (typeof metafieldsData.discount_pair_targets !== 'undefined') {
                            metafieldsData.discount_pair_targets.forEach((target) => {
                                cartData.items.forEach((item) => {
                                    if (item.product_id === target.id) {
                                        if (debug) console.log(`[LSG] Target match in cart, item.product_id:`, item.product_id);
    
                                        if (typeof item.selling_plan_allocation !== 'undefined') {

                                            if (typeof metafieldsData.discount_pair_code !== 'undefined') {
                                                let checkoutURL = `/checkout?discount=${metafieldsData.discount_pair_code}`;
                                                if (debug) console.log(`[LSG] Applying discount:`, checkoutURL);
                                                checkoutBtnEl?.setAttribute(`href`, checkoutURL);
                                            }
                                        }
                                    }
                                });
                            });
                        }
        
                    }
        
                });
            }
    
        });

    }

}

const toggleNoticeEl = document.querySelector(`.lsg-cart-toggle-notice`);

if (toggleNoticeEl) {
    const toggleNoticeBtnEls    = toggleNoticeEl.querySelectorAll(`[lsg-cart-toggle-btn]`),
          toggleNoticeWrapperEl = toggleNoticeEl.querySelector(`.lsg-cart-toggle-notice__notice-wrapper`);

    toggleNoticeBtnEls.forEach((toggleNoticeBtnEl) => {
        toggleNoticeBtnEl.addEventListener(`click`, e => {

            if (toggleNoticeWrapperEl.classList.contains(`lsg-cart-toggle-notice__open`)) {
                toggleNoticeWrapperEl.classList.remove(`lsg-cart-toggle-notice__open`);
            } else {
                toggleNoticeWrapperEl.classList.add(`lsg-cart-toggle-notice__open`);
            }

        });
    });
}